export enum Rent_Type {
    DY = 'DAILY',
    MY = 'MONTHLY',
    YY = 'YEARLY',
    OP = 'OPENING'
}